// extracted by mini-css-extract-plugin
export var integrationButton = "_ai-0";